export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const ACCESS_INTERVAL = "accessInterval";
export const REFRESH_INTERVAL = "refreshInterval";

export const TOKEN_EXPIRY_KEY = "token_expiry";
